import { render, staticRenderFns } from "./IconBejaard.vue?vue&type=template&id=8a4d94be"
import script from "./IconBejaard.vue?vue&type=script&lang=ts"
export * from "./IconBejaard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports